import { render, staticRenderFns } from "./CreateMagazineModal.vue?vue&type=template&id=ec1e6280&"
import script from "./CreateMagazineModal.vue?vue&type=script&lang=js&"
export * from "./CreateMagazineModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMagazineModal.vue?vue&type=style&index=0&id=ec1e6280&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports